import { Link, Text } from 'Common';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from 'Utils/localization/i18next';
import { captureSentry } from 'Utils/sentry';
import styles from './MissingDataNotification.module.scss';

const TAB_BUTTON_SELECTOR = '[aria-controls="tab-button-account"]';
const EDIT_BUTTON_ID = 'user-mobile-ciam-edit-link';

const MissingDataNotification = props => (
  <div className={styles['missing-data-notification']}>
    <div className={styles['missing-data-notification-content']}>
      <Text bold>{t(props.title)}</Text>
      <Text inline>{t(props.text)} </Text>
      <Text className={styles['missing-data-notification-action-links']}>
        {props.action && (
          <React.Fragment>
            <Link
              underline
              colour="grey-900"
              onClick={() => {
                const tabButton = document.querySelector(TAB_BUTTON_SELECTOR);
                tabButton?.click();

                const editButton = document.getElementById(EDIT_BUTTON_ID);
                editButton?.click();

                tabButton?.scrollIntoView();
                if (!editButton) {
                  captureSentry(
                    `MissingDataNotification: ${EDIT_BUTTON_ID} cannot be clicked`
                  );
                }
              }}
            >
              {t(props.action)}
            </Link>
          </React.Fragment>
        )}
      </Text>
    </div>
    <Link
      underline
      colour="grey-900"
      className={styles['missing-data-notification-dismiss-link']}
      onClick={props.onDismiss}
    >
      {t('common.dismiss')}
    </Link>
  </div>
);

MissingDataNotification.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  action: PropTypes.string,
  tabButtonId: PropTypes.string,
  editButtonId: PropTypes.string,
  onDismiss: PropTypes.func.isRequired
};

export default MissingDataNotification;
